define({
    root: {
        // Toolstrip and QAB context menu
        toolstripLabel: "Toolstrip",
        showLabel: "Show Label",
        hideLabel: "Hide Label",
        QAB: "Quick Access Toolbar",
        removeFromQAB: "Remove from Quick Access Toolbar",
        addToQAB: "Add to Quick Access Toolbar",
        qabDefaultDropdownLabel: "Common Controls",
        qabOverflowDropdownLabel: "More Controls",
        restoreFactoryControls: "Restore Defaults",
        restoreFactoryControlsDialogTitle: "Confirm Restore",
        restoreFactoryControlsDialogMessage: "All customizations will be deleted and the Quick Access Toolbar will be restored to the default settings.​",
        minimizeToolstrip: "Minimize Toolstrip",
        restoreToolstrip: "Restore Toolstrip",
        closeWidget: "Close \"${0}\" Tab",
        removeWidget: "Remove \"${0}\" from Gallery",
        homeButtonLabel: "MATLAB Home",

        // Gallery
        gallerySearch: "Search",
        showMore: "Show more",
        noSearchMatchNode:"No items match your search.",
        emptyCategoryPlaceholder: "This category is empty",
        listView: "Details view",
        iconView: "Icon view",
        navTop: "Move category to top",
        navBottom: "Move category to bottom",
        favStarAdd: "Add to favorites",
        favStarRemove: "Remove from favorites",
        editWidget: "Edit \"${0}\"",
        favoritesCategoryTitle: "FAVORITES"
    },
    "ja-jp": true
});